import { render } from "./StrokeControl.vue?vue&type=template&id=3b471b80&scoped=true"
import script from "./StrokeControl.vue?vue&type=script&lang=js"
export * from "./StrokeControl.vue?vue&type=script&lang=js"

import "./StrokeControl.vue?vue&type=style&index=0&id=3b471b80&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b471b80"]])

export default __exports__